import { render, staticRenderFns } from "./OrdemDeServico.vue?vue&type=template&id=535df2ae&scoped=true"
import script from "./OrdemDeServico.vue?vue&type=script&lang=js"
export * from "./OrdemDeServico.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=535df2ae&prod&scoped=true&lang=css&external"
import style1 from "./OrdemDeServico.vue?vue&type=style&index=1&id=535df2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535df2ae",
  null
  
)

export default component.exports